import RegistrationForm from './js/RegistrationForm';

export default RegistrationForm;
